import { SOURCE_BACKEND } from '@/config/events'

export const ErrorUtil = {
  createErrorResponse(error) {
    return Object.assign(
      {
        status: error?.response?.status ?? 999,
        source: SOURCE_BACKEND,
        infoMessages: []
      },
      error?.response?.data
    )
  }
}
